import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Award, Users, Heart, Sparkles, Star } from 'lucide-react';
import { treatments, differentials, testimonials } from '../data/mock';
import { clinicInfo } from '../data/mock';

const Home = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="section-padding" style={{
        background: 'linear-gradient(to bottom, var(--bg-primary) 0%, var(--bg-secondary) 100%)',
        minHeight: '80vh',
        display: 'flex',
        alignItems: 'center'
      }}>
        <div className="container">
          <div className="grid-two-column">
            <div style={{ maxWidth: '600px' }}>
              <h1 className="hero-large" style={{ marginBottom: '24px' }}>
                Sorrisos que transformam vidas. Tecnologia, estética e cuidado em cada detalhe.
              </h1>
              <p className="body-large" style={{ marginBottom: '40px', color: 'var(--text-secondary)' }}>
                A OdontoDentine é uma clínica odontológica completa, comprometida em oferecer tratamentos personalizados com tecnologia de ponta e atendimento humanizado.
              </p>
              <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
                <a 
                  href={`https://wa.me/${clinicInfo.phone.replace(/[^0-9]/g, '')}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-primary"
                >
                  Agendar Avaliação
                </a>
                <Link to="/tratamentos" className="btn-secondary">
                  Conheça os Tratamentos
                </Link>
              </div>
            </div>
            <div style={{
              background: 'var(--bg-secondary)',
              borderRadius: '0px',
              height: '500px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              border: '1px solid var(--border-light)'
            }}>
              <div style={{ textAlign: 'center', padding: '40px' }}>
                <Sparkles size={80} style={{ color: 'var(--text-light)', marginBottom: '16px' }} />
                <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>Imagem da clínica</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="section-padding" style={{ background: 'var(--bg-primary)' }}>
        <div className="container">
          <div style={{ maxWidth: '800px', margin: '0 auto', textAlign: 'center' }}>
            <h2 className="hero-medium" style={{ marginBottom: '24px' }}>Sobre a OdontoDentine</h2>
            <p className="body-large" style={{ color: 'var(--text-secondary)' }}>
              A OdontoDentine é uma clínica odontológica completa, comprometida em oferecer tratamentos personalizados com tecnologia de ponta e atendimento humanizado. Nossa missão é devolver a saúde e a estética do sorriso com conforto, segurança e excelência.
            </p>
          </div>
        </div>
      </section>

      {/* Differentials Section */}
      <section className="section-padding" style={{ background: 'var(--bg-secondary)' }}>
        <div className="container">
          <h2 className="hero-medium" style={{ textAlign: 'center', marginBottom: '60px' }}>Nossos Diferenciais</h2>
          <div className="grid-product-showcase">
            {differentials.map((differential, index) => {
              const icons = [Award, Users, Heart, Sparkles];
              const Icon = icons[index % icons.length];
              return (
                <div key={differential.id} style={{
                  background: 'var(--bg-primary)',
                  border: '1px solid var(--border-light)',
                  borderRadius: '0px',
                  padding: '40px',
                  textAlign: 'center',
                  transition: 'all 0.2s ease'
                }}>
                  <div style={{
                    width: '64px',
                    height: '64px',
                    margin: '0 auto 24px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    border: '1px solid var(--border-medium)',
                    borderRadius: '0px'
                  }}>
                    <Icon size={32} style={{ color: 'var(--text-primary)' }} />
                  </div>
                  <h3 className="heading-2" style={{ marginBottom: '12px' }}>{differential.title}</h3>
                  <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                    {differential.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Treatments Section */}
      <section className="section-padding" style={{ background: 'var(--bg-primary)' }}>
        <div className="container">
          <h2 className="hero-medium" style={{ textAlign: 'center', marginBottom: '60px' }}>Nossos Tratamentos</h2>
          <div className="grid-product-showcase">
            {treatments.map((treatment) => (
              <div key={treatment.id} className="product-card">
                <div style={{
                  width: '100%',
                  height: '280px',
                  background: 'var(--bg-secondary)',
                  marginBottom: '16px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  border: '1px solid var(--border-light)'
                }}>
                  <Sparkles size={48} style={{ color: 'var(--text-light)' }} />
                </div>
                <h3 className="product-card-title">{treatment.title}</h3>
                <p className="product-card-description">{treatment.description}</p>
                <Link to="/tratamentos" className="btn-icon" style={{ padding: '16px' }}>
                  Saiba mais <ArrowRight size={16} />
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="section-padding" style={{ background: 'var(--bg-secondary)' }}>
        <div className="container">
          <h2 className="hero-medium" style={{ textAlign: 'center', marginBottom: '60px' }}>Depoimentos</h2>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '32px'
          }}>
            {testimonials.map((testimonial) => (
              <div key={testimonial.id} style={{
                background: 'var(--bg-primary)',
                border: '1px solid var(--border-light)',
                borderRadius: '0px',
                padding: '32px'
              }}>
                <div style={{ display: 'flex', gap: '4px', marginBottom: '16px' }}>
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} size={16} fill="var(--text-primary)" style={{ color: 'var(--text-primary)' }} />
                  ))}
                </div>
                <p className="body-regular" style={{ marginBottom: '16px', color: 'var(--text-secondary)' }}>
                  "{testimonial.text}"
                </p>
                <p className="body-small" style={{ fontWeight: 700, color: 'var(--text-primary)' }}>
                  {testimonial.name}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section-padding" style={{
        background: 'var(--bg-primary)',
        textAlign: 'center'
      }}>
        <div className="container">
          <h2 className="hero-medium" style={{ marginBottom: '24px' }}>
            Agende sua avaliação e descubra o poder de um sorriso saudável e bonito.
          </h2>
          <p className="body-large" style={{ marginBottom: '40px', color: 'var(--text-secondary)' }}>
            Nossa equipe está pronta para cuidar do seu sorriso com excelência e dedicação.
          </p>
          <a 
            href={`https://wa.me/${clinicInfo.phone.replace(/[^0-9]/g, '')}`}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary"
          >
            Agendar Avaliação
          </a>
        </div>
      </section>
    </div>
  );
};

export default Home;